import { atomWithStorage } from 'jotai/utils'

const welToken:string = "";

export const AtomWelToken = atomWithStorage<string>('wel-token', welToken);